var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mb-5" },
            [
              _c("message", {
                staticStyle: { "white-space": "pre-line" },
                attrs: {
                  description: _vm.$t("apeironGwApp.guia.decripcion"),
                  variant: "info",
                },
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _vm.issste
                        ? _c(
                            "b-link",
                            {
                              attrs: { href: _vm.guiaISSSTE, target: "_blank" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    type: "button",
                                    id: "id-guia-issste",
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("apeironGwApp.guia.descarga")
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "icon-descargar" }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _vm.isApoyos
                        ? _c(
                            "b-link",
                            {
                              attrs: { href: _vm.guiaApoyos, target: "_blank" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    type: "button",
                                    id: "id-guia-apoyos",
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("apeironGwApp.guia.descarga")
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "icon-descargar" }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _vm.isGeneral
                        ? _c(
                            "b-link",
                            {
                              attrs: {
                                href: _vm.guiaGeneral,
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button", id: "id-guia" },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("apeironGwApp.guia.descarga")
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "icon-descargar" }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }